"use client"
import { X } from "lucide-react"
import * as React from "react"

import { cn } from "@/lib/tailwind"
import { IconButton, type IconButtonProps } from "./IconButton"

export const CloseButton = React.forwardRef<HTMLButtonElement, Omit<IconButtonProps, "ref" | "icon" | "aria-label">>(
  function _CloseButton(props, ref) {
    const size = {
      xs: "size-3",
      sm: "size-4",
      md: "size-5",
      lg: "size-6",
    }[props.size ?? "md"]
    return (
      <IconButton
        ref={ref}
        variant="ghost"
        icon={<X className={size} />}
        aria-label="close"
        size={props.size ?? "sm"}
        {...props}
        className={cn(props.className, "rounded-sm p-0")}
      />
    )
  },
)
